import { useUserSettings } from "./useUserSettings";
import correctSound from "../assets/correct_sound.wav";

/**
 * Hook for playing the correct sound that respects user settings
 */
export const useSound = () => {
  const { settings } = useUserSettings();

  /**
   * Play the correct sound if sound effects are enabled
   */
  const playCorrectSound = () => {
    // Skip if the user disabled sound effects
    if (settings?.isSoundEffectsEnabled === false) {
      return;
    }

    try {
      const audio = new Audio(correctSound);
      audio.volume = 0.5;
      audio.play().catch((error) => {
        console.warn("Error playing sound:", error);
      });
    } catch (error) {
      console.warn("Error creating audio:", error);
    }
  };

  return { playCorrectSound };
};
